import React, { useState } from 'react'

import { normalize, usePet } from '../../modules'

import Modal from "../resusable/modal"

const Shelf = ({ toggle, visible, order, onPerform }) => {
    const [owner, setOwner] = useState()
    const [notes, setNotes] = useState()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Bill has been shelved', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('toggleShelfBill', {
        id: order?._id,
        owner,
        notes
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Shelfing this bill...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Shelf Bill"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Owner of Bill
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-owner"
                        type="text"
                        value={ owner }
                        onChange={ e => setOwner(e.target.value)}
                        placeholder="Simon Kamau" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Notes
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        value={ notes }
                        onChange={ e => setNotes(e.target.value)}
                        placeholder="Any reminders" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Shelf Bill</button>
            </div>
        </Modal>
    )
}

export default Shelf